// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"ec1d994f","449":"20cf9eaf","463":"5252183e","917":"36169bef"}[chunkId] + ".chunk.js";
};